const GridIcon = ({ className, ...rest }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 18 18"
    className={className ? className : "w-4 h-4"}
    {...rest}
  >
    <g fill="currentColor" clipPath="url(#clip0_10604_136679)">
      <path d="M7.665 4H4.854A.855.855 0 0 0 4 4.854v2.81c0 .471.383.854.854.854h2.81c.471 0 .854-.383.854-.853V4.854A.855.855 0 0 0 7.665 4M13.146 4h-2.81a.855.855 0 0 0-.854.854v2.81c0 .471.383.854.853.854h2.811c.471 0 .854-.383.854-.853V4.854A.855.855 0 0 0 13.146 4M7.665 9.482H4.854a.855.855 0 0 0-.854.853v2.811c0 .471.383.854.854.854h2.81c.471 0 .854-.383.854-.854v-2.81a.855.855 0 0 0-.853-.854M13.146 9.482h-2.81a.855.855 0 0 0-.854.853v2.811c0 .471.383.854.853.854h2.811c.471 0 .854-.383.854-.854v-2.81a.855.855 0 0 0-.854-.854"></path>
    </g>
    <defs>
      <clipPath id="clip0_10604_136679">
        <path fill="currentColor" d="M4 4h10v10H4z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default GridIcon;
